import { IParamHandle, param, service } from "@spawn/core";
import { RevealUncoverTier } from "@spawn/reveal";
import { getUncoverTierFromWinFactor } from "../network/helpers";

/** Decides the uncover tier of the revealed mysteries. */
@service
export class UncoverTierService {
	/**
	 * When true, the uncover tier follows the win factor of the spin (quick, normal or exceptional).
	 * When false, every reveal uses the normal tier.
	 */
	@param({ default: false }) tieredUncover!: IParamHandle<boolean>;

	public fromWinFactor(winFactor: number | undefined): RevealUncoverTier {
		return this.tieredUncover() ? getUncoverTierFromWinFactor(winFactor) : RevealUncoverTier.Normal;
	}
}
